export const environment = {
  production: true,
  buildId: '3760172387223331',
  configFile: 'config.json',
};
